module.exports = "/lucky-balls/img/weager/Lower_Raise/Button_Lower.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Lower_Raise/Button_Lower.png
// module id = 1165
// module chunks = 0